export default __webpack_public_path__ + "static/media/bgCampaign.c95d5b3b.png";